import { TFunction } from "i18next";

export enum Languages {
    FR = "fr",
    DE = "de",
}

export function getCurrentLanguageTranslation(t: TFunction, language: string) {
    return {
        value: language?.toString(),
        label: t(language ? `languages.${language}` : ""),
    };
}
